export enum EntityType {
  Guest = 'Guest',
  Vehicle = 'Vehicle',
  Pet = 'Pet',
  ResidentAddress = 'ResidentAddress',
  AccessCard = 'AccessCard',
  Citation = 'Citation',
}

export enum Action {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
}

export const entityTypeMap: Record<EntityType, string> = {
  [EntityType.Guest]: 'Guest',
  [EntityType.Vehicle]: 'Vehicle',
  [EntityType.Pet]: 'Pet',
  [EntityType.ResidentAddress]: 'ResidentAddress',
  [EntityType.AccessCard]: 'AccessCard',
  [EntityType.Citation]: 'Citation',
};

export const actionMap: Record<Action, string> = {
  [Action.Create]: 'Create',
  [Action.Update]: 'Update',
  [Action.Delete]: 'Delete',
};

export const entityTypeOptions = [
  { value: EntityType.Guest, label: entityTypeMap[EntityType.Guest] },
  { value: EntityType.Vehicle, label: entityTypeMap[EntityType.Vehicle] },
  { value: EntityType.Pet, label: entityTypeMap[EntityType.Pet] },
  { value: EntityType.ResidentAddress, label: entityTypeMap[EntityType.ResidentAddress] },
  { value: EntityType.AccessCard, label: entityTypeMap[EntityType.AccessCard] },
  { value: EntityType.Citation, label: entityTypeMap[EntityType.Citation] },
];

export const actionOptions = [
  { value: Action.Create, label: actionMap[Action.Create] },
  { value: Action.Update, label: actionMap[Action.Update] },
  { value: Action.Delete, label: actionMap[Action.Delete] },
];
